<template>
  <v-card outlined class="mb-3 rounded-lg">
    <v-card-text>
      <!-- Title -->
      <div class="font-weight-bold mb-2">
        {{ action.title }}
        <span class="grey--text font-italic"> ({{ action.dateLabel }}) </span>
      </div>

      <!-- Cost -->
      <div class="d-flex justify-space-between grey--text">
        <span>Coût actuel</span>
        <span>{{ action.cost }} €</span>
      </div>

      <!-- ========================================= -->
      <!-- PAST / REALISED                          -->
      <!-- ========================================= -->

      <template v-if="action.isPast">
        <div class="d-flex justify-space-between grey--text mt-2">
          <span> Date dernier {{ action.type }} </span>

          <span>
            {{ formatDate(action.lastDate) }}
          </span>
        </div>
      </template>

      <!-- ========================================= -->
      <!-- FUTURE / TO DO                           -->
      <!-- ========================================= -->

      <template v-else>
        <!-- Gain -->
        <div class="d-flex justify-space-between green--text mt-2">
          <span>
            Gain scénario choisi par {{ action.type }} (vs. Initial)
          </span>

          <strong>
            {{ formatGain(action.gain) }}
          </strong>
        </div>

        <!-- Last completed date -->
        <div
          v-if="action.lastDate"
          class="d-flex justify-space-between grey--text mt-2"
        >
          <span> Date dernier {{ action.type }} </span>

          <span>
            {{ formatDate(action.lastDate) }}
          </span>
        </div>

        <!-- Frequency -->
        <div
          v-if="action.freq"
          class="d-flex justify-space-between grey--text mt-1"
        >
          <span>
            Fréquence
            {{ action.type === "nettoyage" ? "Nettoyage" : "Élagage" }}
            choisie
          </span>

          <span>
            {{ action.freq }}
          </span>
        </div>
      </template>

      <!-- Status -->
      <div class="d-flex justify-end mt-3">
        <v-btn
          disabled
          small
          :color="action.isPast ? 'grey lighten-1' : 'blue'"
          :dark="!action.isPast"
        >
          {{ action.isPast ? "RÉALISÉ" : "À RÉALISER" }}
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    action: {
      type: Object,
      required: true,
    },
  },

  methods: {
    formatGain(value) {
      const gain = Number(value) || 0;

      if (gain > 0) {
        return `+${gain} €`;
      }

      return `${gain} €`;
    },

    formatDate(dateStr) {
      if (!dateStr) return "";

      const d = new Date(dateStr);

      return `${String(d.getDate()).padStart(2, "0")}/${String(
        d.getMonth() + 1
      ).padStart(2, "0")}/${d.getFullYear()}`;
    },
  },
};
</script>
